import React, { useEffect, useState } from 'react';
import { FiEye, FiTrash2, FiInfo, FiCalendar, FiRefreshCw  } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

export default function ReportSequence() {
  const navigate = useNavigate();
  const [relatorios, setRelatorios] = useState([]);

  useEffect(() => {
    const salvos = JSON.parse(localStorage.getItem('relatorios')) || [];
    setRelatorios(salvos);
  }, []);

  const excluirRelatorio = (id) => {
    const atualizados = relatorios.filter(relatorio => relatorio.id !== id);
    setRelatorios(atualizados);
    localStorage.setItem('relatorios', JSON.stringify(atualizados));
  };

  const irParaNovoRelatorio = () => {
    navigate('/new-report');
  };

  return (
      <div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            <div
              onClick={irParaNovoRelatorio}
              className="flex flex-col justify-center items-center border-[#3f1057]/20 border-2 border-dashed cursor-pointer h-64 bg-gray-50 hover:bg-[#3f1057]/5 text-center py-2 rounded-2xl transition-colors duration-300 ease-in-out"
            >
              <p className="font-semibold text-[#3f1057]/80 text-lg">Novo Relatório</p>
              <p className="text-[#3f1057]/60 text-sm mt-2">Crie um novo relatório personalizado</p>
            </div>

            {relatorios.map(relatorio => (
              <div key={relatorio.id} className="bg-white rounded-lg border border-gray-200 flex flex-col">
                <div className="p-6 flex-1">
                  <div className="flex justify-between items-start mb-4">
                    <h2 className="text-lg font-semibold text-gray-800 truncate max-w-[80%]">{relatorio.titulo}</h2>
                    <button className="text-gray-400 hover:text-blue-500 transition-colors duration-200 p-1.5 rounded-full hover:bg-gray-50">
                      <FiInfo size={16} />
                    </button>
                  </div>

                  <div className="mt-6 space-y-3">
                    <div className="flex items-center text-sm text-gray-600">
                      <FiCalendar size={15} className="text-gray-400 mr-2.5" />
                      <span>Criado em: {relatorio.dataCriacao}</span>
                    </div>
                    <div className="flex items-center text-sm text-gray-600">
                      <FiRefreshCw size={15} className="text-gray-400 mr-2.5" />
                      <span>Atualizado em: {relatorio.dataAtualizacao}</span>
                    </div>
                  </div>
                </div>

                <div className="p-3 flex justify-between items-center ">
                  <button className="flex items-center text-gray-600 hover:text-blue-600 px-3 py-1.5 rounded-md transition-colors duration-200 hover:bg-white">
                    <FiEye size={16} className="mr-2" />
                    <span className="font-medium">Visualizar</span>
                  </button>

                  <div className="flex space-x-2">
                    <button
                      onClick={() => excluirRelatorio(relatorio.id)}
                      className="p-1.5 text-gray-500 hover:text-red-500 rounded-md hover:bg-white transition-all duration-200"
                    >
                      <FiTrash2 size={16} />
                    </button>
                  </div>
                </div>
              </div>
            ))}

          </div>
        </div>
  );
}
